import { BlogPost } from '@/types/blog';
import { content } from './content';

export const kostolanyFinanzweisheitPost: BlogPost = {
  title: 'André Kostolany: Die Kunst über Geld nachzudenken - Zeitlose Börsenweisheit für moderne Anleger',
  metaTitle: 'Kostolany: Zeitlose Börsenweisheit für Anleger',
  date: '18.09.2025',
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  category: 'Finanzwissen',
  tags: ['André Kostolany', 'Börsenpsychologie', 'Anlagestrategie', 'Finanzbildung', 'Investmentphilosophie', 'Buchtipps'],
  excerpt: 'André Kostolany prägte mich als jungen Finanzinteressierten nachhaltig. Seine zeitlosen Börsenweisheiten aus "Die Kunst über Geld nachzudenken" sind heute relevanter denn je. Entdecken Sie die 4 Gs und das Ei des Kostolany für Ihren Anlageerfolg.',
  imageUrl: "/kostolany-hero-modern.jpg",
  content,
  slug: 'kostolany-finanzweisheit',
  metaDescription: 'Kostolanys zeitlose Börsenweisheit: Die 4 Gs und das Ei des Kostolany für moderne Anleger. Finanzpsychologie und Anlagestrategie.',
};